import type { ReactNode } from 'react';

export const symbol_outbox: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m453-611-58 58q-9 9-21 9t-21.39-9q-8.61-9-8.61-21.5t9-21.5l109-110q5-5 10.13-7 5.14-2 11-2 5.87 0 10.87 2 5 2 10 7l110 110q9 9 9 21t-8.61 21q-9.39 9-21.89 9t-21.5-9l-58-57v159q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-159ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600v-136H634q-26 40-67.5 61.5T480-233q-45 0-86.5-21.5T326-316H180v136Zm300.02-113q34.98 0 64.48-17.5Q574-328 591-359q7-10 18.5-13.5T633-376h147v-404H180v404h147q12 0 23.5 3.5T369-359q17 31 46.52 48.5 29.51 17.5 64.5 17.5ZM180-180h600-600Z"
		/>
	</svg>
);
